"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MatchSearchHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null,
        "The Matching Tool allows Members to match",
        react_1.default.createElement("a", { href: 'https://help.themlc.com/en/support/what-is-a-sound-recording' }, "\u00A0sound recordings\u00A0"),
        "to works within their catalog. This ensures you'll collect the royalties you're owed for your work(s)."),
    react_1.default.createElement("p", null, "The first step is to locate recordings not yet matched to your works by entering criteria in the search fields below. Search results are sorted by relevance and will be grouped together based on similar data."),
    react_1.default.createElement("p", null, "In the next step, you can locate the specific work in your catalog that you want to match.")));
exports.default = MatchSearchHeader;
